// Shared helpers for interpreting matrix cell values coming from the API.
// Raw cell codes: "\u2714" included, "+" add-on, "\u22A1" included in add-on above, "\u0394" separate purchase,
// "" not included, anything else = text ("|" is a line break).

export const SYMBOLS = {
  check: "\u2714",
  addon: "+",
  included: "\u22A1",
  separate: "\u0394",
};

export const LEGEND = [
  { symbol: SYMBOLS.check, label: "Included in the license" },
  { symbol: SYMBOLS.addon, label: "Add-on available for purchase with this license" },
  { symbol: SYMBOLS.included, label: "Included in the add-on listed above" },
  { symbol: SYMBOLS.separate, label: "Available for separate purchase (not dependent on the license)" },
  { symbol: "Text", label: "Service plan level or capacity included (e.g. Plan 1, 50 GB, Read only)" },
  { symbol: "Optional", label: "Available with or without Microsoft Teams (unbundled SKU)" },
];

export const parseCell = (raw) => {
  if (!raw) return { kind: "none" };
  if (raw === SYMBOLS.check) return { kind: "check" };
  if (raw === SYMBOLS.addon) return { kind: "addon" };
  if (raw === SYMBOLS.included) return { kind: "included" };
  if (raw === SYMBOLS.separate) return { kind: "separate" };
  return { kind: "text", text: String(raw).split("|") };
};

export const cellToText = (raw, style = "csv") => {
  const cell = parseCell(raw);
  switch (cell.kind) {
    case "check":
      return style === "csv" ? "Yes" : SYMBOLS.check;
    case "addon":
      return style === "csv" ? "Add-on" : SYMBOLS.addon;
    case "included":
      return style === "csv" ? "In add-on" : SYMBOLS.included;
    case "separate":
      return style === "csv" ? "Separate purchase" : SYMBOLS.separate;
    case "text":
      return cell.text.join(" ");
    default:
      return "";
  }
};

export const formatPrice = (value, symbol = "$", estimated = false) => {
  if (value === null || value === undefined) return "";
  if (Number(value) === 0) return "Free";
  const num = Number(value).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${estimated ? "\u2248" : ""}${symbol}${num}`;
};

export const sortByOrder = (list) => [...list].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
